<template>
  <note :note="log.data" :application-id="applicationId">
    <template #header>
      <div class="rounded-t-md bg-grey-hover px-4 py-2 font-medium">
        <span class="cursor-pointer" data-cy="task-deal-link" @click="openDeal">
          {{ log.business_legal_name ?? $t("COMMON.DEAL_LINK") }}
        </span>
      </div>
    </template>
  </note>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router";

import { ROUTE_DEAL_PROGRESS } from "@/router/routes";

import Note from "@/views/deals/components/dealNotes/Note.vue";

import type { NoteLog } from "@/models/communicationLogs";

const { log } = defineProps<{
  log: NoteLog;
}>();

const router = useRouter();

const applicationId = computed(() => log?.application_id?.toString());

const dealRoute = computed(() =>
  router.resolve({
    name: ROUTE_DEAL_PROGRESS,
    params: { id: applicationId.value },
  })
);

const openDeal = () => {
  if (!applicationId.value) {
    return;
  }
  window.open(dealRoute.value.href, "_blank");
};
</script>
